import { debounce } from 'lodash-es';
import dom from '../utils/dom';
import domEffects from '../utils/dom-effects';
import Fields from './OnePageGivingFormFields';

/** @typedef {import("../tnew/lib/FieldValidationProvider").default} FieldValidationProvider */


class CustomAmountInput {
  /**
   * @param {HTMLFormElement} $form
   * @param {FieldValidationProvider} validationProvider
   * @param {Function} notifyChange
   */
  constructor($form, validationProvider, notifyChange) {
    this.notifyChange = notifyChange;

    /** @type {HTMLInputElement} */
    this.$input = dom.findFrom($form, `[name="${Fields.Amount}"]`);

    if (!this.$input) {
      return;
    }

    this.$container = dom.findFrom($form, '.tn-opg-form__custom-amount-input-container');

    validationProvider.addFieldListener(Fields.Amount, 'validationstart', this.onValidationStart);
    validationProvider.addFieldListener(Fields.Amount, 'validationcomplete', this.onValidationComplete);

    this.isAmountValid = !!this.value;

    this.initInputHandlers(validationProvider);
  }

  /**
   * @param {FieldValidationProvider} validationProvider
   */
  initInputHandlers(validationProvider) {
    const validate = debounce(() => validationProvider.validateField(Fields.Amount), 250);

    let previousRawValue = this.rawValue;

    this.$input.addEventListener('input', () => {
      const { rawValue } = this;

      if (previousRawValue === rawValue) {
        return;
      }

      previousRawValue = rawValue;

      this.isAmountValid = false;
      this.notifyChange();

      validate();
    });
  }

  get rawValue() {
    if (this.$input) {
      return this.$input.value;
    }

    return '';
  }

  get value() {
    const value = parseFloat(this.rawValue);

    if (!value) {
      return 0;
    }

    return value;
  }

  onValidationStart = (field) => {
    if (field.value === this.rawValue) {
      return;
    }

    this.isAmountValid = false;
    this.notifyChange();
  }

  onValidationComplete = (field, results) => {
    if (field.value !== this.rawValue) {
      return;
    }

    this.isAmountValid = results.isValid;
    this.notifyChange();
  }

  expand() {
    if (this.$container) {
      domEffects.expand(this.$container);
    }
  }

  collapse() {
    if (this.$container) {
      domEffects.collapse(this.$container);
    }
  }
}

export default CustomAmountInput;



// WEBPACK FOOTER //
// ./src/onePageGiving/CustomAmountInput.js